import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

/**
 * useLoanTypeCode — derives the current loan-type code from the form value.
 *
 * Watches the `loanTypeId` field in the form context and resolves it to
 * the matching `code` string (e.g. "REFI", "CONS", "PURC") from the
 * Redux loanTypes store. This survives step mount/unmount cycles because
 * the source of truth is the shared FormProvider, not local state.
 *
 * @param {string} scope — form field prefix (e.g. "details")
 * @returns {string|null} loan type code or null
 */
export default function useLoanTypeCode(scope) {
  const loanTypeId = useWatch({ name: `${scope}.loanTypeId` });
  const { loanTypes: records } = useSelector(state => state.loanTypes);

  return useMemo(() => {
    if (!loanTypeId || !records?.length) return null;
    const match = records.find(lt => lt.parameterId === loanTypeId);
    return match?.code ?? null;
  }, [loanTypeId, records]);
}

